import React from 'react'
import { MdAddCall } from "react-icons/md";
import { PiBuildingOffice } from "react-icons/pi";
import Warning from './Warning';

const AddressBar = () => {
  return (
    <div className="w-full">
      <div className="w-full bg-green-800 text-white py-1.5 px-2 flex items-center justify-end">
        {/* <Warning/> */}

        {/* Right side: Mobile Number */}
        <div className="flex items-center space-x-1 whitespace-nowrap bg-green-900 px-3 py-1 rounded text-xs sm:text-sm font-semibold shrink-0 shadow">
          <MdAddCall className="mx-1 font-medium size-4 sm:size-5" />
            <a href="tel:+919891904233">
           <span>+91 9891904233</span>
          </a>
        </div>

      </div>
    </div>
  )
}

export default AddressBar